<template>
  <div>
    <the-nav-bar :title="$t('invite.name')" />
    <div class="body-wrapper" v-if="isLoaded">
      <md-input-item
        v-model="inviteCode"
        :placeholder="$t('invite.placeholder')"
        :brief="$t('invite.brief')"
        :disabled="isSubmitting"
        type="text"
        @change="onInputChange"
      ></md-input-item>
      <md-button
        :type="disabled ? 'disabled' : 'primary'"
        :loading="isSubmitting"
        @click="onSubmit"
      >
        <span>{{ $t('common.submit') }}</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Button, Dialog, InputItem, Toast } from 'mand-mobile';
import { mapState } from 'vuex';
import { postBindInviter } from '@/api/user.js';
export default {
  name: 'inviteCode',
  components: {
    TheNavBar,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
  },
  data() {
    return {
      inviteCode: '',
      isSubmitting: false,
      isLoaded: false,
    };
  },
  computed: {
    ...mapState({ userInfo: state => state.userInfo }),
    disabled() {
      return this.isSubmitting || this.inviteCode.length < 6;
    },
  },
  mounted() {
    let promise = Promise.resolve();
    if (!this.userInfo.inviter) {
      promise = this.$store.dispatch('updateUserInfo');
    }
    promise
      .then(() => {
        if (!this.userInfo.inviter) {
          if (this.$route.query.code) {
            this.inviteCode = this.$route.query.code;
            this.onInputChange();
          }
        } else {
          this.$router.go(-1);
        }
        this.isLoaded = true;
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    onInputChange() {
      this.$nextTick(() => {
        let output = this.inviteCode.toUpperCase();
        output = output.replace(/[^0-9A-Z]/, '');
        this.inviteCode = output;
      });
    },
    onSubmit() {
      this.isSubmitting = true;
      postBindInviter(this.inviteCode)
        .then(data => {
          this.isSubmitting = false;
          Toast.succeed(this.$t('invite.bindSuccess'));
          this.$store.commit('setUserInfo', { inviter: data.data.inviter });
          this.$router.back();
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'warn-color',
            title: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 4.8vw;

  .md-button {
    margin-top: 4.8vw;
  }

  & >>> {
    .md-field-item-content:before {
      display: none;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      padding: 0 2.13vw;
      border-radius: 2.67vw;
      background: #f8fbfc;
    }
  }
}
</style>
